import { loadScheduledDeploymentsAction } from "fleet/redux-store/scheduled-deployments/actions";
import { all, put, takeLatest } from "redux-saga/effects";
import { USER_LOGIN } from "redux-store/auth/actions";

function* fleetInitSaga() {
  yield takeLatest(USER_LOGIN, bootstrap);
}

function* bootstrap() {
  // Bootstrap the stores.
  yield all([put(loadScheduledDeploymentsAction)]);
}

export { fleetInitSaga };
